<span *ngIf="!isEditing" (click)="startEditing($event)" class="editable-title">{{ value }}</span>
<div *ngIf="isEditing">
  <div class="fields-edit">
    <input matInput [(ngModel)]="value" class="editInput" (click)="stopPropagation($event)" (keydown)="handleKeyDown($event)">
    <mat-icon matSuffix (click)="closeEditTitle($event)" class="close-edit">check</mat-icon>
  </div>
  <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
</div>
